let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hB099"), load("9CDY0"), load("6vzdH"), load("ei0Jg")]).then(() => parcelRequire('esrJ1'));